module.exports = __webpack_public_path__ + "img/chokodadler_plain.a28cc584.jpg";